import {PageTitle} from '../../../_metronic/layout/core';
import {useIntl} from 'react-intl';
import TabComponent from '../../common/components/TabComponent';
import Orders from './orders/Orders';
import {OrderStatus} from '../../interfaces/order';

interface OrderTrackingProps {
    activeKey: string;
}

const OrderTracking = ({activeKey}: OrderTrackingProps): JSX.Element => {
    const intl = useIntl();

    return (
        <>
            <PageTitle breadcrumbs={[]}>
                {intl.formatMessage({id: 'MENU.MY_ACCOUNT'})}
            </PageTitle>
            <TabComponent
                tabData={[
                    {
                        title: intl.formatMessage({id: 'MENU.ORDER_TRACKING.IN_PROGRESS'}),
                        key: 'in-progress',
                        to: '/orders/in-progress',
                        content: <Orders status={OrderStatus.IN_PROGRESS} />,
                        permissions: ['voirCommandesEnCoursResilie'],
                    },
                    {
                        title: intl.formatMessage({id: 'MENU.ORDER_TRACKING.ISSUED'}),
                        key: 'delivered-orders',
                        to: '/orders/delivered-orders',
                        content: <Orders status={OrderStatus.ISSUED} />,
                        permissions: ['voirCommandesEnCoursResilie'],
                    },
                    {
                        title: intl.formatMessage({id: 'MENU.ORDER_TRACKING.CANCELED'}),
                        key: 'canceled-orders',
                        to: '/orders/canceled-orders',
                        content: <Orders status={OrderStatus.CANCELED} />,
                        permissions: ['voirCommandesEnCoursResilie'],
                    },
                ]}
                activeKey={activeKey}
            />
        </>
    );
};

export default OrderTracking;
